import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Route } from 'react-router';
import { loadingAsyncState } from 'widgets-for-react';
import { fetchEventDetails } from '../../backendApi/EventsApi';
import { previousOrDefault } from '../../utils/asyncState';
import { emptyJumbo } from '../Jumbo/Jumbo';
import { EventDetailsWidget } from './EventDetails/EventDetailsWidget';
import { EventOverviewWidget } from './EventOverview/EventOverviewWidget';
export const EventRoutes = (props)=>{
    if (props.config == 'off') return [];
    const { state, setState, eventsOverviewClassNames, config: { prefix, loadJumbo, Jumbo }, pageRenderer } = props;
    return [
        /*#__PURE__*/ _jsx(Route, {
            path: `${prefix}`,
            exact: true,
            render: (param)=>{
                let { history } = param;
                const s0 = state.eventOverview;
                const jumboContent = s0.jumboContent.kind == 'unloaded' ? loadingAsyncState(loadJumbo, emptyJumbo) : s0.jumboContent;
                return EventOverviewWidget({
                    ...state.eventOverview,
                    jumboContent,
                    Jumbo,
                    eventsOverviewClassNames,
                    history,
                    route: prefix
                }).run((updateEventOverview)=>setState((prevState)=>({
                            ...prevState,
                            eventOverview: updateEventOverview(prevState.eventOverview)
                        })));
            }
        }, "events/overview"),
        /*#__PURE__*/ _jsx(Route, {
            path: `${prefix}/:eventId+`,
            render: (route)=>{
                var _event_value_CMSContent;
                const s0 = state.eventDetails;
                const eventId = route.match.params['eventId'] || s0.eventId;
                const event = eventId == s0.eventId ? s0.event : loadingAsyncState(fetchEventDetails(eventId), previousOrDefault(s0.event, null));
                if (event.kind == 'loaded' && ((_event_value_CMSContent = event.value.CMSContent) === null || _event_value_CMSContent === void 0 ? void 0 : _event_value_CMSContent.Kind) == 'fullReplacement') {
                    var _event_value_CMSContent1;
                    return pageRenderer(`/node/${(_event_value_CMSContent1 = event.value.CMSContent) === null || _event_value_CMSContent1 === void 0 ? void 0 : _event_value_CMSContent1.Id}`, route.history);
                }
                return EventDetailsWidget({
                    ...state.eventDetails,
                    eventId,
                    event,
                    Jumbo,
                    eventsOverviewClassNames,
                    history: route.history
                }).run((eventDetails)=>setState((prevState)=>({
                            ...prevState,
                            eventDetails
                        })));
            }
        }, "events/details")
    ];
};
